import {useState, useEffect} from "react";
import {createPortal} from "react-dom";
import {X} from "lucide-react";

/** 名刺画像ビューア（フルスクリーンオーバーレイ） */
export function BizcardImageViewer({front, back, initialSide, onClose}: {front?: string; back?: string; initialSide: "front" | "back"; onClose: () => void}) {
  const [side, setSide] = useState(initialSide);
  const src = side === "front" ? front : back;
  const hasBoth = !!front && !!back;

  // 背景スクロールを禁止
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // ESC キーで閉じる
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return createPortal(
    <div className="fixed inset-0 z-[100] flex flex-col bg-black/90" role="dialog" aria-label="名刺画像ビューア">
      {/* ヘッダー: タブ + 閉じるボタン */}
      <div className="px-md pb-sm flex items-center justify-between" style={{paddingTop: "max(env(safe-area-inset-top), 2.75rem)"}}>
        {hasBoth ? (
          <div className="gap-sm flex">
            <button type="button" className={`px-md py-xs rounded-full text-sm font-bold transition-colors ${side === "front" ? "bg-white text-black" : "text-white/70"}`} onClick={() => setSide("front")}>
              表面
            </button>
            <button type="button" className={`px-md py-xs rounded-full text-sm font-bold transition-colors ${side === "back" ? "bg-white text-black" : "text-white/70"}`} onClick={() => setSide("back")}>
              裏面
            </button>
          </div>
        ) : (
          <span className="text-sm text-white/70">{front ? "表面" : "裏面"}</span>
        )}
        <button type="button" onClick={onClose} className="p-sm text-white/70" aria-label="閉じる">
          <X className="size-6" />
        </button>
      </div>

      {/* 画像エリア: タップで閉じる */}
      <div className="p-md pb-safe-min flex flex-1 items-center justify-center" onClick={onClose}>
        {src && <img src={src} alt={side === "front" ? "名刺表面" : "名刺裏面"} className="max-h-full max-w-full object-contain" onClick={(e) => e.stopPropagation()} />}
      </div>
    </div>,
    document.body,
  );
}
